export default __webpack_public_path__ + "static/avatar1-8e0bb422b5d424b6c393553ee8b4bdc6.jpg";